import { useEffect, useRef } from 'react';

import { useModal } from '../../../ModalContext';
import useStore from '../../../store/store';
import { FixedNumber } from '../../../utility';

const HeightRuler = ({ height, gRef, textOnLeft, onHeightChange }) => {
	const rulerGroup = useRef();
	const lineRef = useRef();
	const textRef = useRef();
	const arrowRef = useRef();
	const getUnitFromMeter = useStore((state) => state.getUnitFromMeter);
	const distance = useStore((state) => state.distance);
	const triggerModal = useModal();

	useEffect(() => {
		const g = rulerGroup.current = gRef.current.group()
			.attr({ class: 'clickable' })
			.transform({ translateX: textOnLeft ? -12 : 12 });
		lineRef.current = g.polyline().stroke({ color: '#000', width: '1' });
		textRef.current = g.text().font({ anchor: textOnLeft ? 'end' : 'start' }).id('text');

		g.polygon('0 0 -3 -5 3 -5').stroke({ color: '#000', width: '1' }).transform({ scale: 0.8 });
		arrowRef.current = g.polygon('0 0 -3 5 3 5').stroke({ color: '#000', width: '1' }).transform({ scale: 0.8 });
		g.rect().fill('transparent').id('rect');

		return () => g.remove();
	}, [gRef.current]);

	useEffect(() => {
		if (lineRef.current) {
			lineRef.current.plot(`0,0 0,-${getUnitFromMeter(height)}`);
		}

		if (textRef.current) {
			textRef.current
				.text(`${FixedNumber(height)}m`)
				.transform({ translate: [textOnLeft ? -10 : 10, -getUnitFromMeter(height) / 2] });
		}
		if (arrowRef.current) {
			arrowRef.current
				.transform({ scale: 0.8, translateY: -getUnitFromMeter(height) });
		}
		if (rulerGroup.current) {
			rulerGroup.current.findOne('#rect')
				.attr({
					width: '12px',
					height: getUnitFromMeter(height),
				})
				.transform({ translate: { x: -6, y: -getUnitFromMeter(height) } });
		}
	}, [gRef.current, height, distance]);

	useEffect(() => {
		const onSave = (newValue) => onHeightChange(newValue);
		rulerGroup.current.click(() => triggerModal(
			'H:',
			FixedNumber(height),
			onSave,
			rulerGroup.current.findOne('#text').node
		));
		return () => {
			rulerGroup.current.click(null);
		};
	}, [gRef.current, rulerGroup.current, height, onHeightChange]);

	return null;
};

export { HeightRuler };